import { Button } from 'flowbite-react';
import { FaFileExport } from "react-icons/fa6";
import axios from "axios";

export default function RightPanel( {showOutput} ) {

  // console.log(showOutput.type)
  const handleExportPDF = (event) => {
    event.preventDefault()

    const filename = localStorage.getItem('filename_pdf')
    // console.log(filename)
    if( filename !== null && filename.search(showOutput.type) !== -1) {
      let fileid = filename.split(".")[0];
      // axios.get(`http://localhost:5000/api/export/pdf/${fileid}`);
      axios.get(process.env.REACT_APP_SERVER_URL + `/api/export/pdf/${fileid}`, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then((response) => {
        // console.log(response)
        const blob = new Blob([response.data], {type: 'application/pdf'})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      })
    } else {
        alert('Please generate the questions first!')
    }

  }

  return (
    <div className="p-6">
      <div className="mb-4">
        <div className="flex space-x-2 mb-5">
          {/* <Button className='w-half bg-primary text-white rounded-md hover:bg-secondary hover:text-black transition duration-300 icon_buttons'><FaShareAlt />Share </Button> */}
          {/* <Button className='w-half bg-primary text-white rounded-md hover:bg-secondary hover:text-black transition duration-300 icon_buttons'><FaExternalLinkAlt /> Study</Button> */}
          {/* <Button className='w-half bg-primary text-white rounded-md hover:bg-secondary hover:text-black transition duration-300 icon_buttons'><FaEdit />Edit</Button> */}
          <Button onClick={handleExportPDF} className='w-half bg-primary text-white rounded-md hover:bg-secondary hover:text-black transition duration-300 icon_buttons'> <FaFileExport />Export PDF</Button>
          {/* <Button className='w-half bg-primary text-white rounded-md hover:bg-secondary hover:text-black transition duration-300 icon_buttons'> <FaFileExport />Export Word</Button> */}
        </div>
      </div>
      {showOutput?.html?.length > 0 && (
        <div className="html_response">
          {showOutput.html}
        </div>
      )}
    </div>
  );
}
